<template>
  <div id="subevent-add-update-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie v-if="createLoading == 'created'" key="create-loading" />
        <el-row v-else key="content">
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.title") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.titleMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input v-model="form.title"></el-input>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>

            <el-col :span="24" class="mt-3">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("registrationManagement.additionalProducts.dialog.content") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("registrationManagement.additionalProducts.dialog.contentMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <quill-editor ref="myQuillEditor" @ready="onEditorReady($event)" :options="editorOption" v-model="form.notes" />
                <span class="error">{{ $errorMessage("notes", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10" v-if="form">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="form.enableRegistrationAutomation = !form.enableRegistrationAutomation">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.registrationAutomation") }}</label>
                      <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.registrationAutomationMsgPrd") }}</span>
                  </div>
                  <div class="section-switch" @click.stop>
                    <el-switch v-model="form.enableRegistrationAutomation"></el-switch>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="form.enableRegistrationAutomation">
                    <el-collapse-transition>
                      <div v-show="form.enableRegistrationAutomation">
                        <el-row>
                          <el-row :gutter="10" class="mt-3">
                            <el-col :span="24">
                              <el-button-group class="w-100 switch-btn-container">
                                <el-button :type="form.controlType == 0 ? 'primary' : ''" size="mini" round @click="changeType(0)">{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.packaceBased") }}</el-button>
                                <el-button :type="form.controlType == 1 ? 'primary' : ''" size="mini" round @click="changeType(1)">{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.additionalServiceBased") }}</el-button>
                              </el-button-group>
                            </el-col>
                          </el-row>
                          <el-col :span="24" class="mt-3">
                            <div class="register-form-content" v-for="item in registerFormList" :key="item.id">
                              <div class="content-title">{{ item.title }} ({{ getEnumsDisplay("RegistrationFormLanguage", item.language) }} - {{ getEnumsDisplay("Currency", item.currency) }})</div>
                              <template v-if="form.controlType == 0">
                                <div class="packet-list" v-for="packet in item.packets" :key="packet.packetId">
                                  <div class="packet-title">{{ packet.title }}</div>
                                  <el-switch :value="form.registrationControlItems.some(x => x.id == packet.packetId)" @change="packetListChange(packet.packetId)"></el-switch>
                                </div>
                              </template>
                              <template v-if="form.controlType == 1">
                                <div class="packet-list" v-for="service in item.additionalServices" :key="service.id">
                                  <div class="packet-title">{{ service.title }}</div>
                                  <el-switch :value="form.registrationControlItems.some(x => x.id == service.id)" @change="packetListChange(service.id)"></el-switch>
                                </div>
                              </template>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </el-collapse-transition>
                  </div>
                </transition>
              </div>

              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="top">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.view") }}
                            <!-- <el-tooltip content="Content" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isActive"></el-switch>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="form.enableStockControl ? 'sactive' : ''">
                      <div class="custom-set-inner">
                        <i :class="form.enableStockControl ? 'fas fa-ticket-alt' : 'fas fa-ticket-alt'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.limit") }}
                            <!-- <el-tooltip content="Content" placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.limitMsgPrd") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.enableStockControl"></el-switch>
                      </div>
                      <div class="custom-set-actions fcenter mt-3" v-show="form.enableStockControl">
                        <el-row class="mt-3" :gutter="10" style="width: 100%;">
                          <el-col :span="12">
                            <div class="registerform-input-container">
                              <div class="custom-label">
                                <label>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.stock") }}</label>
                                <el-tooltip placement="top">
                                  <div slot="content" class="custom-tooltip-content">
                                    <span>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.stockMsg") }}</span>
                                  </div>
                                  <i class="el-icon-info"></i>
                                </el-tooltip>
                              </div>
                              <el-input-number v-model="form.stock" :min="0"></el-input-number>
                              <span class="error">{{ $errorMessage("stock", validationErrors) }}</span>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div class="registerform-input-container">
                              <div class="custom-label">
                                <label>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.stockControl") }}</label>
                                <el-tooltip placement="top">
                                  <div slot="content" class="custom-tooltip-content">
                                    <span>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.stockControlMsg") }}</span>
                                  </div>
                                  <i class="el-icon-info"></i>
                                </el-tooltip>
                              </div>
                              <el-select v-model="form.stockControl">
                                <el-option v-for="(item, index) in getEnums.find(x => x.title == 'AdditionalProductStockControl').enums" :key="index" :label="item.displayName" :value="item.key"></el-option>
                              </el-select>
                              <span class="error">{{ $errorMessage("stockControl", validationErrors) }}</span>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                    <div class="custom-set-container" :class="false ? 'sactive' : 'swaiting'">
                      <div class="custom-set-inner">
                        <i class="fas fa-qrcode"></i>
                        <div class="custom-set-info">
                          <label
                            >{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.controlCenter") }}
                            <!-- <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.controlCenterMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-button round type="primary" size="mini" @click="$router.push({ path: 'venues' })">{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.goControlCenter") }}</el-button>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="createLoading != 'created'">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.close") }}</el-button>
        <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash"> {{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'save'" :disabled="loading == 'save'" @click="save">{{ $t("registrationManagement.subeventRegistrations.subeventAddUpdate.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionLibrary from "./register-form/QuestionLibrary.vue";
import axios from "axios";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import moment from "moment";
import { quillEditor } from "vue-quill-editor";
export default {
  components: { quillEditor, QuestionLibrary },
  name: "AdditionalProductAddUpdate",
  props: ["id"],
  mounted() {
    this.$store.dispatch("getVenues");
  },
  data() {
    return {
      settingsDock: false,
      createLoading: false,
      activeKey: null,
      loading: false,
      form: {
        id: null,
        title: null,
        isActive: true,
        notes: null,
        stock: 0,
        stockControl: 0,
        enableStockControl: false,
        enableRegistrationAutomation: false,
        controlType: 0,
        registrationControlItems: []
      },
      editorOption: {
        modules: {
          toolbar: [["bold", "italic", "underline", "strike"], [{ color: [] }, { background: [] }], ["clean"], ["link", "image"]],
          syntax: {
            highlight: text => hljs.highlightAuto(text).value
          }
        }
      },
      logoPercent: 0,
      axios,
      validationErrors: [],
      moment,
      timeout: null
    };
  },
  methods: {
    goControlPoint() {
      this.$router.push({ name: "venues" }).catch(() => {});
    },
    packetListChange(id) {
      if (this.form.registrationControlItems.some(x => x.id == id)) {
        var cindex = this.form.registrationControlItems.findIndex(x => x.id == id);
        console.log(cindex);
        this.form.registrationControlItems.splice(cindex, 1);
      } else {
        this.form.registrationControlItems.push({ id: id });
      }
    },
    changeType(type) {
      this.form.controlType = type;
      this.form.registrationControlItems = [];
    },
    onEditorReady(editor) {
      editor.root.setAttribute("data-placeholder", this.$t("enterText"));
      editor.getModule("toolbar").addHandler("image", () => {
        this.selectLocalImage(editor);
      });
    },
    async itemAddedVenue(item) {
      await this.$store.dispatch("getVenues");
      this.form.venueID = item.id;
    },
    deleteItem() {
      this.$emit("deleteMe", this.form.id);
      this.$emit("closeDialog");
    },
    save() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = "save";
      this.validationErrors = [];
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("addUpdateProduct", this.form);
        this.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
          await this.$store.dispatch("getProducts");
        }
        this.loading = false;
      }, 500);
    },
    logoProgress(event) {
      this.logoPercent = event.percent;
    },
    logoSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.image = response.data;
      }
    },
    selectLocalImage(editor) {
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.click();
      input.onchange = () => {
        const file = input.files[0];
        if (/^image\//.test(file.type)) {
          this.saveToServer(file, editor);
          this.quillUploading = "Image upload process started.";
        } else {
          //console.warn("You could only upload images.");
          this.quillUploading = "You could only upload images.";
          setTimeout(() => {
            this.quillUploading = false;
          }, 3000);
        }
      };
    },
    saveToServer(file, editor) {
      const fd = new FormData();

      fd.append("image", file);
      const xhr = new XMLHttpRequest();
      xhr.open("POST", axios.defaults.baseURL + "event/uploadImage?uploadType=html&language=" + this.$i18n.locale, true);
      xhr.setRequestHeader("Authorization", "Bearer " + localStorage.getItem("token"));

      xhr.onload = () => {
        if (xhr.status === 200) {
          const body = JSON.parse(xhr.responseText);
          if (body.alert.hasError == false) {
            const url = body.data.item.url;
            this.insertToEditor(url, editor);
            this.quillUploading = "Image upload process completed successfully.";
            setTimeout(() => {
              this.quillUploading = false;
            }, 3000);
          } else {
            this.$message.error(body.alert.message);
            this.quillUploading = body.alert.message;
            setTimeout(() => {
              this.quillUploading = false;
            }, 3000);
          }
        } else {
          this.quillUploading = xhr.statusText + " (Code: " + xhr.status + ")";
          setTimeout(() => {
            this.quillUploading = false;
          }, 3000);
        }
      };

      xhr.send(fd);
    },

    insertToEditor(url, editor) {
      editor.insertEmbed(editor.getSelection().index, "image", url);
    },
    async getProduct() {
      this.createLoading = "created";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        if (this.id != undefined && this.id != null) {
          var res = await this.$store.dispatch("getProductOne", this.id);
          this.form = res.data.data.item;
        }
        this.createLoading = false;
      }, 500);
    }
  },

  mounted() {},
  computed: {
    getEnums() {
      return this.$store.getters.getEnums;
    },
    registerFormList() {
      return this.$store.getters.getRegisterFormList;
    }
  },
  async created() {
    await this.getProduct();
  }
};
</script>
<style lang="less" scoped>
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
.registerform-input-container {
  .tag-container {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .badge-list {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    .badger {
      border-radius: 8px;
      background-color: #f3f3f3;
      height: 20px;
      padding: 10px;
    }
  }
  .title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    label {
      font-weight: bold;
      color: black;
      margin-bottom: 0;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
  }
  display: flex;
  flex-direction: column;
  .el-input-number {
    width: 100%;
  }
}
.control-point-info {
  padding: 1rem 2rem;
  .container-info {
    background-color: #eaeaea;
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    border-radius: 8px;
    .qr-img {
      i {
        font-size: 40px;
      }
    }
    .title {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      .el-button {
        width: 150px;
        font-weight: 600;
      }
    }
  }
}
.add-manager-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  .add-manager-title {
    padding: 1rem;
    background-color: #f3f3f3;
    flex-direction: row;
    display: flex;
    gap: 1rem;
    align-items: center;
    .add-m-title {
      font-weight: bold;
    }
    .add-m-title,
    .add-m-btn {
      flex-shrink: 0;
    }
    .add-m-input {
      width: 100%;
    }
  }
}
.area-maps-title {
  display: grid;
  grid-template-columns: 1fr 8fr 6fr 2fr 1fr;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  background-color: #eaeaea;
  font-weight: bold;
  margin-bottom: 0.5rem;
  gap: 1rem;
}
.subevent-add-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  .item {
    .img-title {
      display: flex;
      gap: 1rem;
      font-weight: 500;
      align-items: center;
      .img-title-alt {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        .networking-title {
          display: flex;
          flex-direction: column;
          gap: 0.1rem;
          font-weight: bold;
          .color-title {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 0.5rem;
            font-weight: 400;
          }
        }
      }
      & > img {
        border-radius: 8px;
      }
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f3f3f3;
    &.passive {
      background-color: #ffe5e5 !important;
    }
    display: grid;
    grid-template-columns: 1fr 8fr 6fr 2fr 1fr;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;

    gap: 1rem;
    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      &.me {
        color: #ccc;
      }
      font-size: 20px;
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
.circle-color-pick {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  flex-shrink: 0;
}
.cover-image {
  height: 250px;
}

.link-area-title {
  display: grid;
  grid-template-columns: 1fr 4fr 6fr 1fr 1fr;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  background-color: #eaeaea;
  font-weight: bold;
  margin-bottom: 0.5rem;
  gap: 1rem;
}
.link-area-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  .item {
    .img-title {
      display: flex;
      gap: 1rem;
      font-weight: 500;
      align-items: center;
      .img-title-alt {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        .networking-title {
          display: flex;
          flex-direction: column;
          gap: 0.1rem;
          font-weight: bold;
          .color-title {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 0.5rem;
            font-weight: 400;
          }
        }
      }
      & > img {
        border-radius: 8px;
      }
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f3f3f3;
    &.passive {
      background-color: #ffe5e5 !important;
    }
    display: grid;
    grid-template-columns: 1fr 4fr 6fr 1fr 1fr;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;

    gap: 1rem;
    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      &.me {
        color: #ccc;
      }
      font-size: 20px;
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}

.gallery-area-title {
  display: grid;
  grid-template-columns: 1fr 9fr 1fr 1fr;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  background-color: #eaeaea;
  font-weight: bold;
  margin-bottom: 0.5rem;
  gap: 1rem;
}
.gallery-area-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  .item {
    .img-title {
      display: flex;
      gap: 1rem;
      font-weight: 500;
      align-items: center;
      .img-title-alt {
        display: flex;
        flex-direction: flex;
        gap: 0.5rem;
        align-items: center;
        & > img {
          border-radius: 8px;
        }
        .networking-title {
          display: flex;
          flex-direction: column;
          gap: 0.1rem;
          font-weight: bold;
          .color-title {
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 0.5rem;
            font-weight: 400;
          }
          & > span {
            color: rgb(159, 217, 231);
          }
        }
      }
      & > img {
        border-radius: 8px;
      }
    }
    transition: all 0.5s;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    background-color: #f3f3f3;
    &.passive {
      background-color: #ffe5e5 !important;
    }
    display: grid;
    grid-template-columns: 1fr 9fr 1fr 1fr;
    padding: 10px;
    align-items: center;
    border-radius: 8px;
    transition: all 0.5s;

    gap: 1rem;
    & > .price-title {
      font-weight: bold;
      flex-direction: row;
      gap: 0.5rem;
      .el-input {
        width: 100%;
      }
    }
    .el-input-number {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    i.burger {
      &.me {
        color: #ccc;
      }
      font-size: 20px;
    }
    & > .title {
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & > i.el-icon-loading {
        font-size: 20px;
      }
    }

    & > div:last-child {
      justify-self: flex-end;
    }
    .table-icon {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-weight: bold;
    }
  }
}
.model-base-mid {
  min-width: 1140px;
}
.model-base-small {
  min-width: 550px;
}
.model-base-mini {
  min-width: 400px;
}
.switch-btn-container {
  display: flex;
  .el-button {
    flex-grow: 1;
  }
}
.register-form-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-block: 1rem;
  .content-title {
    background-color: #eaeaea;
    padding: 0.5rem 1rem;
    font-weight: bold;
    border-radius: 8px;
  }
  .packet-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    padding: 0.5rem 1rem;
    .packet-title {
      text-decoration: underline;
      color: #03658c;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AdditionalProductAddUpdate.vue